// 按需加载view-design组件
import Vue from 'vue'
import {
  Affix,
  Alert,
  Anchor,
  AnchorLink,
  AutoComplete,
  Avatar,
  BackTop,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Carousel,
  Cascader,
  Cell,
  Checkbox,
  Col,
  Collapse,
  ColorPicker,
  Content,
  DatePicker,
  Divider,
  Drawer,
  Dropdown,
  Footer,
  Form,
  Header,
  Icon,
  Input,
  InputNumber,
  Scroll,
  Sider,
  Split,
  Layout,
  List,
  LoadingBar,
  Menu,
  Message,
  Modal,
  Notice,
  Option,
  OptionGroup,
  Page,
  Poptip,
  Progress,
  Radio,
  Rate,
  Row,
  Select,
  Slider,
  Spin,
  Steps,
  Switch,
  Table,
  Tabs,
  Tag,
  Time,
  Timeline,
  TimePicker,
  Tooltip,
  Transfer,
  Tree,
  Upload,
  locale
} from 'view-design'

import lang from 'view-design/dist/locale/zh-CN'
locale(lang)

Vue.component('Affix', Affix)
Vue.component('Alert', Alert)
Vue.component('Anchor', Anchor)
Vue.component('AnchorLink', AnchorLink)
Vue.component('AutoComplete', AutoComplete)
Vue.component('Avatar', Avatar)
Vue.component('BackTop', BackTop)
Vue.component('Badge', Badge)
Vue.component('Breadcrumb', Breadcrumb)
Vue.component('BreadcrumbItem', Breadcrumb.Item)
Vue.component('Button', Button)
Vue.component('ButtonGroup', Button.Group)
Vue.component('Card', Card)
Vue.component('Carousel', Carousel)
Vue.component('CarouselItem', Carousel.Item)
Vue.component('Cascader', Cascader)
Vue.component('Cell', Cell)
Vue.component('CellGroup', Cell.Group)
Vue.component('Checkbox', Checkbox)
Vue.component('CheckboxGroup', Checkbox.Group)
Vue.component('Col', Col)
Vue.component('Collapse', Collapse)
Vue.component('ColorPicker', ColorPicker)
Vue.component('Content', Content)
Vue.component('DatePicker', DatePicker)
Vue.component('Divider', Divider)
Vue.component('Drawer', Drawer)
Vue.component('Dropdown', Dropdown)
Vue.component('DropdownItem', Dropdown.Item)
Vue.component('DropdownMenu', Dropdown.Menu)
Vue.component('Footer', Footer)
Vue.component('Form', Form)
Vue.component('FormItem', Form.Item)
Vue.component('Header', Header)
Vue.component('Icon', Icon)
Vue.component('Input', Input)
Vue.component('InputNumber', InputNumber)
Vue.component('Scroll', Scroll)
Vue.component('Sider', Sider)
Vue.component('Split', Split)
Vue.component('Submenu', Menu.Sub)
Vue.component('Layout', Layout)
Vue.component('List', List)
Vue.component('ListItem', List.Item)
Vue.component('ListItemMeta', List.Item.Meta)
Vue.component('LoadingBar', LoadingBar)
Vue.component('Menu', Menu)
Vue.component('MenuGroup', Menu.Group)
Vue.component('MenuItem', Menu.Item)
Vue.component('Message', Message)
Vue.component('Modal', Modal)
Vue.component('Notice', Notice)
Vue.component('Option', Option)
Vue.component('OptionGroup', OptionGroup)
Vue.component('Page', Page)
Vue.component('Panel', Collapse.Panel)
Vue.component('Poptip', Poptip)
Vue.component('Progress', Progress)
Vue.component('Radio', Radio)
Vue.component('RadioGroup', Radio.Group)
Vue.component('Rate', Rate)
Vue.component('Row', Row)
Vue.component('Select', Select)
Vue.component('Slider', Slider)
Vue.component('Spin', Spin)
Vue.component('Step', Steps.Step)
Vue.component('Steps', Steps)
Vue.component('iSwitch', Switch)
Vue.component('Table', Table)
Vue.component('Tabs', Tabs)
Vue.component('TabPane', Tabs.Pane)
Vue.component('Tag', Tag)
Vue.component('Time', Time)
Vue.component('Timeline', Timeline)
Vue.component('TimelineItem', Timeline.Item)
Vue.component('TimePicker', TimePicker)
Vue.component('Tooltip', Tooltip)
Vue.component('Transfer', Transfer)
Vue.component('Tree', Tree)
Vue.component('Upload', Upload)

Vue.prototype.$Loading = LoadingBar
Vue.prototype.$Message = Message
Vue.prototype.$Modal = Modal
Vue.prototype.$Notice = Notice
Vue.prototype.$Spin = Spin
